// Utility functions for local storage operations
import MockStorage from "./MockStorage";

// Importing keys from a centralized definition file
// and re-exporting them for easier access
export * as keys from "#/def/store-keys";

// For environments where localStorage is not available, use the mock implementation
const storage =
  typeof window?.localStorage?.getItem === "function"
    ? window.localStorage
    : new MockStorage();

export function get(key, defaultValue = null) {
  // getting stored value
  const saved = storage.getItem(key);
  const initial = JSON.parse(saved);
  return initial || defaultValue;
}

export function set(key, value) {
  // storing input name
  if (value === undefined || value === null) {
    storage.removeItem(key);
  } else {
    storage.setItem(key, JSON.stringify(value));
  }
}
